module.exports = __webpack_public_path__ + "img/nansheng.6c2704e2.png";